import { Tabs, Box, Tab, Panel } from "@bca/ui-library";

import { SalesPageLayout, SalesPageTitle } from "./SalesPageLayout";
import { TabButton } from "./TabButtons";
import TabContent from "./TabContent";
import SalesError from "./SalesError";

interface SalesPageErrorProps {
  user?: { firstName: string; lastName: string };
  idToken?: string;
  isToUseAuthZero: boolean;
  isAuthenticated: boolean;
  logoutUrl?: string;
  week: Date[];
  activeTabIndex: number;
}

const SalesPageError: React.FunctionComponent<SalesPageErrorProps> = ({
  user,
  idToken,
  isToUseAuthZero,
  isAuthenticated,
  logoutUrl,
  week,
  activeTabIndex,
}: any) => {
  return (
    <SalesPageLayout
      user={user}
      idToken={idToken}
      isToUseAuthZero={isToUseAuthZero}
      isAuthenticated={isAuthenticated}
      logoutUrl={logoutUrl}
    >
      <Tabs activeTabIndex={activeTabIndex}>
        <div
          style={{
            backgroundImage:
              "linear-gradient(to bottom, rgba(7, 11, 22, 0) 35%, rgba(7, 11, 22, 0) 130%), linear-gradient(to bottom, #091535, #091535)",
          }}
        >
          <SalesPageTitle></SalesPageTitle>
          <Box
            maxWidth={["100%", "calc(100% - 48px)", "976px", "976px"]}
            style={{
              overflow: "auto",
              whiteSpace: "nowrap",
              backgroundImage:
                "linear-gradient(to bottom, rgba(7, 11, 22, 0) 35%, rgba(7, 11, 22, 0) 130%), linear-gradient(to bottom, #091535, #091535)",
              paddingLeft: "0",
              margin: "0 auto",
              height: "73px",
            }}
          >
            {week.map((day, index) => {
              return (
                <Tab key={index}>
                  <TabButton>
                    <TabContent
                      day={day}
                      index={index}
                      lotsCount={-1}
                      saleCount={-1}
                    ></TabContent>
                  </TabButton>
                </Tab>
              );
            })}
          </Box>
        </div>

        <Panel>
          <SalesError></SalesError>
        </Panel>
        <Panel>
          <SalesError></SalesError>
        </Panel>
        <Panel>
          <SalesError></SalesError>
        </Panel>
        <Panel>
          <SalesError></SalesError>
        </Panel>
        <Panel>
          <SalesError></SalesError>
        </Panel>
        <Panel>
          <SalesError></SalesError>
        </Panel>
        <Panel>
          <SalesError></SalesError>
        </Panel>
      </Tabs>
    </SalesPageLayout>
  );
};

export default SalesPageError;
